import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import { canNavigate } from '@/libs/acl/routeProtection'
import { getHomeRouteForLoggedInUser, getUserData, isUserLoggedIn } from '@/auth/utils'
import { getGames, GAME } from '@/utils/game'
import errors from './routes/errors'
import auth from './routes/auth'
import profile from './routes/profile'
import senior from './routes/senior'
import master from './routes/master'
import agent from './routes/agent'
import player from './routes/player'
import transaction from './routes/transaction'
import balanceReport from './routes/balanceReport'
import cockBalanceReport from './routes/cockBalanceReport'
import baccaratBalanceReport from './routes/baccaratBalanceReport'
import slotBalanceReport from './routes/slotBalanceReport'
import assistant from './routes/assistant'
import lottoBalanceReport from './routes/lottoBalanceReport'
import lotto12BalanceReport from './routes/lotto12BalanceReport'
import lotteryBalanceReport from './routes/lotteryBalanceReport'
import balanceReportSport99 from './routes/balanceReportSport99'
import requestDeposit from './routes/requestDeposit'
import requestWithdraw from './routes/requestWithdraw'

const games = getGames()

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue'),
      meta: {
        pageTitle: 'breadcrumb.home',
        resource: 'home',
        breadcrumb: [
          {
            text: 'breadcrumb.home',
            active: true,
          },
        ],
      },
    },
    ...errors,
    ...auth,
    ...profile,
    ...senior,
    ...master,
    ...agent,
    ...player,
    ...assistant,
    ...transaction,
    ...balanceReport,
    ...cockBalanceReport,
    ...baccaratBalanceReport,
    ...(games.includes(GAME.Joker) ? slotBalanceReport : []),
    ...(games.includes(GAME.Lotto) ? lottoBalanceReport : []),
    ...(games.includes(GAME.Lotto12) ? lotto12BalanceReport : []),
    ...(games.includes(GAME.Vn99) ? lotteryBalanceReport : []),
    ...(games.includes(GAME.Sport99) ? balanceReportSport99 : []),
    ...requestDeposit,
    ...requestWithdraw,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

// Method using PUSH
const RouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
  return RouterPush.call(this, to)
    .catch(err => err)
}

// Method using Replace
const RouterReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(to) {
  return RouterReplace.call(this, to)
    .catch(err => err)
}

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()
  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'login' })

    // If logged in => not authorized
    return next({ name: 'not-authorized' })
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()
    next(getHomeRouteForLoggedInUser(userData ? 'admin' : null))
  }

  return next()
})

export default router
